console.log("Initialized!");

// /**
//  * Checks if the script is currently running on a product page by attempting to get the product's API object.
//  */
// async function onProductPage() {
//     const path = window.location.pathname;
//     // The pathname most likely looks like /collections/something/products/product-handle
//     const potentialHandle = path.substring(path.lastIndexOf("/") + 1);
//     const result = await fetch(`/products/${potentialHandle}.json`, {
//         method: "GET",
//         headers: {
//             "Accept": "application/json"
//         }
//     });

//     return result.status === 200;
// }

// const wut = await onProductPage();
// // console.log('onProductPage()', await onProductPage());
